import { Button, Icon } from "@screencloud/screencloud-ui-components";
import { FilestackUploadedFile } from "src/pages/Welcome/hooks/useCreateQuickPost";
import { UploadedFilesContainer } from "./styles";

type Props = {
  uploadedFiles: FilestackUploadedFile[];
  remainingNumberOfFiles: number;
  setUploadedFiles: React.Dispatch<
    React.SetStateAction<FilestackUploadedFile[]>
  >;
  setRemainingNumberOfFiles: React.Dispatch<React.SetStateAction<number>>;
};

export const UploadedFiles = (props: Props): JSX.Element => {
  const { uploadedFiles, setUploadedFiles, setRemainingNumberOfFiles } = props;

  return (
    <UploadedFilesContainer>
      {uploadedFiles.map((file, index) => (
        <div className="uploaded-file-container" key={file.name + index}>
          <p className="file-name">{`File Name - ${file.name}`}</p>
          <Button
            className="delete-file-button"
            icon
            onClick={() => {
              setUploadedFiles(uploadedFiles.filter((_, i) => i !== index));
              setRemainingNumberOfFiles((prev) => prev + 1);
            }}
          >
            <Icon name="trash" />
          </Button>
        </div>
      ))}
    </UploadedFilesContainer>
  );
};
